import type { InboxThread } from "@tellescope/types-models";
import { Mail, MessageCircle, Phone, Smartphone } from "lucide-react";
import { cn } from "../lib/utils";

export interface ChannelIconProps {
  channel: InboxThread["type"];
  className?: string;
}

export const ChannelIcon = ({ channel, className: providedClassName }: ChannelIconProps) => {
  const className = cn("w-3 h-3 text-primary-muted", providedClassName);

  switch (channel) {
    case "Phone":
      return <Phone className={className} />;
    case "GroupMMS":
    case "SMS":
      return <Smartphone className={className} />;
    case "Chat":
      return <MessageCircle className={className} />;
    case "Email":
      return <Mail className={className} />;
    case "Zendesk":
      return <img src="/zd-icon.png" className="h-2.5 w-2.5 opacity-50" />;
    default: {
      const _exhaustive: never = channel;
      return null;
    }
  }
};
